import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[proLazyimgs]'
})
export class LazyimgsDirective {

  constructor({ nativeElement }: ElementRef<HTMLImageElement>) {
    const supports = 'loading' in HTMLImageElement.prototype;

    if (supports) {
      nativeElement.setAttribute('loading', 'lazy');
    }
  }
}
